export default {
  'navbar.lang': 'Kiswahili',
  'menu.home': 'Nyumbani',
  'menu.dashboard': 'Dashibodi',
  'menu.profile': 'Profaili',
  'menu.settings': 'Mipangilio',


  'user.login.subtitle': 'Weka taarifa zako ili kuendelea',
  'user.login.username': 'Jina la mtumiaji au barua pepe',
  'user.login.password': 'Nenosiri',
  'user.login.forgot': 'Umesahau nenosiri?',
  'user.login.button': 'Ingia',

  'user.register.title': 'Unda akaunti mpya',
  'user.register.button': 'Jisajili',
  'user.register.success': 'Akaunti imetengenezwa. Angalia barua pepe kuthibitisha.',
   

  'user.login.title': 'Skanu Imefanika!',
  'user.login.welcome.subheading': 'Karibu katika ulimwengu ambapo uhuru unakutana na maisha ya kipekee! Skanua. Pata pointi. Ishi kwa uhuru. Ishi kwa kipekee',
  'user.login.description': 'Umefanikiwa skana msimbo wetu wa QR. Ingia au Jisajili hapa chini kudai zawadi zako, pointi na kushinda zawadi za ajabu',
  'user.login.signin.title': 'Ingia',
  'user.login.signin.sub': 'Ili kuingia tafadhali weka nambari yako ya simu tutaweka msimbo wa uthibitisho',
  'user.login.phoneNumberLabel': 'Nambari ya Simu',
  'user.login.enterPhonePlaceholder': 'Weka nambari ya simu',
  'user.login.invalidPhone': 'Nambari ya simu si sahihi',
  'user.login.phoneRequired': 'Nambari ya simu inahitajika',
  'user.login.signingIn': 'Kuingia...',
  'user.login.continue': 'Endelea',
  'user.login.noAccount': 'Huna akaunti?',
  'user.login.signup': 'Jisajili',
  'user.login.footerCopyright': 'Hakimiliki © {year}. Imetolewa na Exceptional Brands',



  'user.register.welcome': 'Karibu !',
  'user.register': 'Jisajili ili kudai zawadi zako',
  'user.register.description': 'Jaza maelezo yako hapa chini ili upate pointi, ufungue zawadi na kushinda zawadi za ajabu',

  'user.register.phone.label': 'Nambari ya Simu',
  'user.register.phone.placeholder': 'Weka nambari ya simu',
  'user.register.phone.required': 'Nambari ya simu inahitajika',
  'user.register.phone.invalid': 'Nambari ya simu si sahihi',

  'user.register.name.label': 'Jina Lako',
  'user.register.name.placeholder': 'mfano: Mark',
  'user.register.name.required': 'Jina linahitajika',

  'user.register.ageGroup.label': 'Kikundi cha umri (Hiari)',
  'user.register.gender.label': 'Jinsia (Hiari)',
  'user.register.gender.male': 'Mwanaume',
  'user.register.gender.female': 'Mwanamke',

  'user.register.terms.agreement': 'Kwa kuendelea, unakubali {termsLink} na {privacyLink} zetu.',
  'user.register.terms.termsOfService': 'Masharti ya Huduma',
  'user.register.terms.privacyPolicy': 'Sera ya Faragha',

  'user.register.creating': 'Inaandaa Profaili…',
  'user.register.create': 'Tengeneza Profaili',

  'user.register.alreadyAccount': 'Tayari una akaunti?',
  'user.register.signin': 'Ingia',

  'user.register.footer.copyright': 'Hakimiliki © {year}. Imetolewa na Exceptional Brands',

  "user.welcome.welcome": "Karibu!",
  "user.welcome.welcome_name": "Karibu {name}!",
  
  'user.welcome.points_earned': 'Hongera, umepata',
  'user.welcome.thank_you': 'Asante kwa kujisajili!',
  'user.welcome.earn_more_points': 'Ili kupata pointi zaidi, toa tathmini za bidhaa zaidi ulichozinunua kwetu.',
  'user.welcome.continue': 'Endelea',
  'user.welcome.logging_in': 'Ingia...',
  "user.welcome.welcome_reward": "Zawadi ya Karibu",
  "user.welcome.points_label": "pointi!",
  "product.button.continue": "Endelea",
  "product.button.selectToContinue": "Chagua bidhaa ili kuendelea",
  "user.welcome.loggingIn": "Kuingia...",
  'scansuccess.review.heading': 'Unaonaje kutoa alama kwa bidhaa?',
  'scansuccess.review.continue': 'Msimbo wa Muuzaji (Hiari)',
  'scansuccess.review.select-product': 'Ongeza msimbo wa muuzaji ili kupata pointi zaidi',
  'scansuccess.review.review-products': 'Tuma Tathmini',

 "product.retailerCode.label": "Nambari ya Muuzaji",
  "product.retailerCode.requiredLabel": "Inahitajika",
  "product.retailerCode.optionalLabel": "Hiari",
  "product.retailerCode.placeholder": "Weka nambari ya muuzaji",
  "product.retailerCode.aria": "Nambari ya muuzaji",
  "product.retailerCode.hintRequired": "Nambari ya muuzaji inahitajika ili kutuma tathmini hii",
  "product.retailerCode.hintOptional": "Ongeza nambari ya muuzaji ili kupata pointi zaidi",
  "product.retailerCode.error.required": "Nambari ya muuzaji inahitajika",
  "product.retailerCode.error.invalid": "Nambari ya muuzaji si sahihi",


 "profile.title": "Wasifu Wangu",
  "profile.tier.member": "Mwanachama",
  "profile.points": "Pointi",
  "profile.pointsEarned": "Pointi Zilizopatikana",
  'scansuccess.continue': 'Endelea',
  "profile.completeTitle": "Kamilisha Wasifu Wako",
  "profile.completeSubtitle": "Pata {points} pointi za ziada!",
  "profile.completedTitle": "Wasifu Umekamilika! ✓",
  "profile.completedSubtitle": "Umepata pointi zote za ziada {points}!",
  "profile.completeButton": "Kamilisha Wasifu (+{points} pt)",
  "profile.redeem": "✓ Wasifu Umekamilika",
"product.review.placeholder": "Andika tathmini... (herufi moja inatosha)",
  "product.review.ariaLabel": "Andika tathmini",
  "profile.field.phoneNo.label": "Nambari ya Simu",
  "profile.field.phoneNo.add": "Weka nambari yako ya simu",
  "profile.field.email.label": "Anuani ya Barua Pepe",
  "profile.field.email.add": "Ongeza barua pepe yako",
  "profile.field.countryCode.label": "Eneo",
  "profile.field.countryCode.add": "Ongeza eneo lako",
  "profile.field.name.label": "Jina",
  "profile.field.name.add": "Ongeza jina lako",
  "profile.field.dateOfBirth.label": "Tarehe ya Kuzaliwa",
  "profile.field.dateOfBirth.add": "Ongeza tarehe yako ya kuzaliwa",

  "profile.pointsPlus": "+{points} pt",

  "profile.modal.updateTitle": "Sasisha {field}",
  "profile.modal.completeTitle": "Kamilisha Wasifu Wako",
  "profile.modal.update": "Sasisha",
  "profile.modal.complete": "Kamilisha Wasifu",
  "profile.modal.cancel": "Ghairi",

  "profile.completedBadge": "Umepata pointi {points}",

  "profile.progressPercent": "{percent}% Imekamilika",
  "profile.progressRemaining": "{percent}% iliyobaki",


  'scansuccess.congratulations.heading': 'Hongera!',
  'scansuccess.congratulations.continue': 'Umefanikiwa kupata',
  'scansuccess.congratulations.select-product': 'Asante Kwa Tathmini Yako',
  'scansuccess.congratulations.review-products': 'Ili kupata pointi zaidi, pima bidhaa zaidi ulizonunua kutoka kwetu',
  'scansuccess.congratulations.create': 'Nenda kwenye Dashibodi',

  'user.brand-product-review.title': 'Chagua Chapa na Bidhaa Ili Kuendelea',
  'user.brand-product-review.continue': 'Endelea',
  'user.brand-product-review.select-product': 'Chagua bidhaa ili kuendelea',
  'user.brand-product-review.review-products': 'Kagua bidhaa zetu ili upate pointi',
  'user.brand-product-review.rate-product': 'Tafadhali pima angalau bidhaa moja hapo juu ili kuendelea',
  'user.brand-product-review.footer': 'Hakimiliki © {year}. Imetolewa na Exceptional Brands',

  'scansuccess.title': 'Matokeo ya skana',
  'scansuccess.scan.message': 'Asante — skana yako imefanikiwa.',
  'scansuccess.scan.instructions': 'Unaweza kudai pointi, kuandika tathmini au kujisajili kwa ofa.',
  'scansuccess.signup.title': 'Jisajili kudai zawadi',
  'scansuccess.signup.button': 'Jisajili',
  'scansuccess.welcomepoints.title': 'Pointi za Karibu',
  'scansuccess.welcomepoints.pointsLabel': 'Pointi zilizotolewa',
  'scansuccess.brandproductreview.title': 'Tathmini ya Bidhaa na Chapa',
  'scansuccess.brandproductreview.leaveReview': 'Acha tathmini',
  'scansuccess.productreview.title': 'Tathmini ya Bidhaa',
  'scansuccess.productreview.submit': 'Tuma tathmini',
  'scansuccess.congratulations.title': 'Hongera!',
  'scansuccess.congratulations.message': 'Umepata pointi — angalia dashibodi yako kudai.',
  'scansuccess.noAccount': 'Huna akaunti?',
  'scansuccess.signup': 'Jisajili',

  "user.register.createProfile": "Tengeneza Akaunti",
  "user.register.creatingProfile": "Inaunda Akaunti...",
  "user.register.termsOfService": "Masharti ya Huduma",
  "user.register.privacyPolicy": "Sera ya Faragha",



  'dashboard.multiplescans.title': 'Skanu nyingi',
  'dashboard.multiplescans.instructions': 'Simamia skanu nyingi na zawadi kwa pamoja.',
  'dashboard.title': 'Karibu!',
  'dashboard.balance': 'Salio Lako',
  'dashboard.balance-sub': 'pointi',
  'dashboard.redeem': 'Dai',
  'dashboard.stat': 'Jumla ya skanu',
  'dashboard.label': 'Zawadi Ulizoshinda',
  'dashboard.redeem.title': 'Dai Pointi Zako',
  'dashboard.redeem.success': 'Dai Zawadi',
  'dashboard.primary-sub': 'Tumia pointi zako kufungua zawadi',
  'dashboard.secondary-btn': 'Skania tena',
  'dashboard.secondary': 'Mwambie Rafiki',
  'dashboard.loyalty': 'Ngazi za Uaminifu',
  'dashboard.5000pts': '5000 pointi',
  'dashboard.100pts': '100 pointi hadi Platinum',
  'dashboard.almost-there': 'Uko karibu!',
  'dashboard.recent': 'Shughuli za hivi karibuni',
  'settings.title': 'Mipangilio',
   'settings.balance': 'Mwanachama wa Dhahabu',
  'settings.balance-sub': 'Pointi',
  'settings.redeem': 'Akaunti',
  'settings.stat': 'Hariri Profaili',
  'settings.label': 'Sasisha habari za kibinafsi',
  'settings.redeem.title': 'Mapendeleo',
  'settings.redeem.success': 'Arifa',
  'settings.primary-sub': 'Mapendeleo ya push na barua pepe',
  'settings.secondary-btn': 'Lugha',
  'settings.secondary': 'Kiingereza (US)',
  'settings.loyalty': 'Msaada na Sheria',
  'settings.5000pts': 'Msaada & Usaidizi',
  'settings.100pts': 'Maswali yanayoulizwa mara kwa mara, wasiliana nasi',
  'settings.almost-there': 'Vigezo na Masharti',
  'settings.recent': 'Taarifa za kisheria',
  'settings.points': 'Sera ya Faragha',
  'settings.data': 'Taarifa za ulinzi wa data',
  'settings.sign': 'Ondoka',

  // 'profile.title': 'Profaili Yangu',
  'profile.balance': '% Imekamilika',
  'profile.balance-sub': '% iliyobaki',
  // 'profile.redeem': '✓ Profaili Imekamilika',
  'profile.stat': 'Taarifa za Profaili',
  'profile.label': 'pt',
  'profile.redeem.title': 'Unganisha Mitandao ya Kijamii',
  'profile.redeem.success': 'Pata pointi kwa kila muunganiko!',
  'profile.primary-sub': 'Facebook',
  'profile.secondary-btn': '+20 pt',
  'profile.secondary': 'Instagram',
  'profile.loyalty': '+20 pt',
  'profile.5000pts': 'X (Twitter)',
  'profile.100pts': '+20 pt',
  'profile.almost-there': 'Unganisha mitandao yako ya kijamii kupata bonasi ya pointi 20!',
  'profile.recent': 'Jaza mashamba yafuatayo kukamilisha profaili yako na kupata ',
  // 'profile.points': 'mapoinzi ya ziada:',
  "country.KE": "Kenya",
  "country.ZW": "Zimbabwe",
  "country.ZA": "Afrika Kusini",
  "country.BJ": "Benini",
  "country.AE": "Falme za Kiarabu",



 "dashboard.welcome": "Karibu!",
  "dashboard.user.unknown": "Mtumiaji",
  "dashboard.balanceLabel": "Salio Lako",
  "dashboard.coinsAlt": "sarafu",
  "dashboard.pointsLabel": "pointi",
  "dashboard.redeemBtn": "Tumia pointi",
  "dashboard.totalScans": "Skana Zote",
  "dashboard.rewardsWon": "Zawadi Umenshinda",
  "dashboard.redeemTitle": "Tumia Pointi Zako",
  "dashboard.redeemRewards": "Tumia Zawadi",
  "dashboard.redeemSub": "Tumia pointi zako kufungua zawadi",
  "dashboard.reviewProducts": "Tathmini Bidhaa",
  "dashboard.referFriend": "Mrejeleo Rafiki",
  "dashboard.tiersTitle": "Ngazi za Uaminifu",
  "dashboard.tier.default": "Member",
  "dashboard.tierTarget": "{max} pts",
  "dashboard.tierRemaining": "{points} hadi ngazi ijayo",
  "dashboard.almostThere": "Karibu sana!",
  "dashboard.recentActivityTitle": "Shughuli za Hivi Karibuni",
  "dashboard.share.title": "Jiunge na Exceptional Brands",
  "dashboard.share.text": "Jiunge nami kwenye Exceptional Brands! Pata pointi kwa kuskana bidhaa na upate zawadi. Tumia link yangu: {url}",
  "dashboard.shareModalTitle": "Nashare na Marafiki",
  "dashboard.shareModalDesc": "Shiriki Exceptional Brands na marafiki zako na upate pointi za ziada wanapojiunga!",
  "dashboard.platform.facebook": "Facebook",
  "dashboard.platform.instagram": "Instagram",
  "dashboard.platform.twitter": "Twitter",
  "dashboard.platform.whatsapp": "WhatsApp",
  "dashboard.shareLinkLabel": "Kiungo chako cha rufaa:",
  "dashboard.share.instagramCopied": "Kiungo kimehifadhiwa kwenye clipboard - bandika kwenye Instagram",
  "dashboard.footerCopyright": "Haki miliki © {year}. Imewezeshwa na Exceptional Brands",
  "dashboard.aria.welcome": "Paneli ya kukaribisha",
  "dashboard.aria.notifications": "Arifa",
  "dashboard.aria.settings": "Mipangilio",

 'dashboard.redeem.points': 'Dai Pointi Zako',
  'dashboard.redeem.subtitle': 'Tumia pointi zako kufungua zawadi',
  'dashboard.redeem.sub': 'pointi',
  'dashboard.redeem.progress': 'Maendeleo ya kufikia Platinum',
  'dashboard.redeem.stat': 'Zawadi Zinazopatikana',
  'dashboard.redeem.label': 'Dai',
  'dashboard.redeem.need': 'Inahitajika',
  'dashboard.redeem.prize': 'Dhawuniloda ya Tuzo',
  'dashboard.redeem.scan': 'Kadri unavyoskanua ndivyo nafasi zako za kushinda kitu cha kushangaza zinavyoongezeka',
  'dashboard.redeem.recent': 'Shughuli za Hivi Karibuni',
  'global.back': 'Rudi',
  'global.next': 'Ifuatayo',
  'global.search.placeholder': 'Tafuta...',
  'validation.required': 'Sehemu hii inahitajika',
  'error.404.title': 'Ukurasa haukupatikana',
  'error.404.subTitle': 'Samahani, hatuwezi kupata ukurasa uliotafuta.',
};
